export interface PushGraphEdge {
  startNodeId: string
  endNodeId: string
}

export default interface PushGraph {
  nodeIds: string[]
  edges: PushGraphEdge[]
}
